import { getLocaleFromBrowserSettings, getValidLocaleCode } from "@snapchat/ads-l10n";
import { DEV, DEV_LOCALES, QUERY_PARAMETER} from "../../constants";
import { getParamValue } from "../../util/queryString";

const getLocale = (ignorePsuedo = false) => {
  const initLocale = getParamValue(QUERY_PARAMETER.LOCALE) || getLocaleFromBrowserSettings();
  if(DEV && !ignorePsuedo && DEV_LOCALES.includes(initLocale)){
    return initLocale;
  }
  return getValidLocaleCode(initLocale);
};

export default getLocale;
